import {observer} from 'mobx-react';
import CalendarsContainerWithState from './CalendarsContainerWithState';
import EmployeeProfileContainer from '../../EmployeeProfileContainer';

const CalendarsContainer = observer(({uiState}) => {
  return (
    <EmployeeProfileContainer uiState={uiState}>
      <CalendarsContainerWithState/>
    </EmployeeProfileContainer>
  );
});

export default CalendarsContainer;
